module.exports = __webpack_public_path__ + "fonts/400-normal-greek-ext.d4831dd.woff2";